export default {
  root: {
    padding: '10px 15px'
  },
};
